import { CancelToken } from "axios";

import { IAPIError } from "shared/types";
import { APIService } from "shared/services";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { IDataKeys, IJSONAPIItem } from "shared/types";
import { IUserHomeBasePatchData } from "Bands/types";

interface IJSONAPIData {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIUserHomeBaseCollection {
  [IDataKeys.userHomeBase]: IJSONAPIData;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class UserHomeBaseService {
  static createUserHomeBase = (
    data: IUserHomeBasePatchData
  ): Promise<IJSONAPIUserHomeBaseCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.post({
          path: API_ENDPOINTS.USER_HOME_BASES,
          data,
        });
        resolve(response as IJSONAPIUserHomeBaseCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.POST_USER_HOME_BASE);
        reject({ error });
      }
    });

  static getUserHomeBases = (
    queryParams?: string | { [key: string]: string | number | undefined | string[] },
    cancelToken?: CancelToken
  ): Promise<IJSONAPIUserHomeBaseCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.get({
          path: API_ENDPOINTS.USER_HOME_BASES,
          data: queryParams,
          cancelToken,
        });
        resolve(response as IJSONAPIUserHomeBaseCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_USER_HOME_BASES);
        reject({ error });
      }
    });

  static editUserHomeBase = (
    id: string,
    data: IUserHomeBasePatchData
  ): Promise<IJSONAPIUserHomeBaseCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.patch({
          path: API_ENDPOINTS.USER_HOME_BASE(id),
          data,
        });
        resolve(response as IJSONAPIUserHomeBaseCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_USER_HOME_BASE);
        reject({ error });
      }
    });

  static deleteUserHomeBase = (id: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.USER_HOME_BASE(id),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.DELETE_USER_HOME_BASE);
        reject({ error });
      }
    });
}
